import React from 'react';
import i18n from '../../common/i18n';
import { NotificationsSwitch } from './NotificationSwitch';
import ExtraServicesSmsSwitch from './ExtraServicesSmsSwitch';
import { HideAccountSumSwitch } from './HideAccountSumSwitch';
import SendGridCard from './SendGridCard';
import UseGridCard from './UseGridCard';

import './ProfileSettings.less';
import { browserInfo } from '../../common/util';
import { InfoPaper } from '../common/Paper';
import HorizontalRule from '../common/HorizontalRule';

export const ProfileSettings = ({ goToMobileDevices }) => {
    return (
        <div className="lh-1-5 pb-30">
            <Heading text={i18n('nui.profileSettings.notifications')} />
            <NotificationSettingField />
            <SettingField label={i18n('nui.profileSettings.sms')} detail={i18n('nui.profileSettings.sms.detail')}>
                <ExtraServicesSmsSwitch />
            </SettingField>
            <Divider />
            <Heading text={i18n('nui.profileSettings.display')} />
            <SettingField label={i18n('nui.profileSettings.accountSum')}>
                <HideAccountSumSwitch />
            </SettingField>
            <Divider />
            <Heading text={i18n('nui.profileSettings.mobileDevices')} />
            <div className="fs-12 c-black-50-2 mt-10">{i18n('nui.profileSettings.mobileDevices.description')}</div>
            <div className="mt-20" data-atid="link-mobile-devices">
                <a onClick={goToMobileDevices} className="fs-14 c-blue">
                    {i18n('nui.profileSettings.mobileDevices.link')}
                </a>
            </div>
            <Divider />
            <Heading text={i18n('nui.profileSettings.useGridCard')} />
            <UseGridCard />
            <Divider />
            <Heading text={i18n('nui.profileSettings.sendDocument')} />
            <div className="fs-12 c-black-50-2 mt-10 mb-20">{i18n('nui.profileSettings.sendGridInfo')}</div>
            <SendGridCard />
        </div>
    );
};

const Heading = ({ text }) => <h2 className="fs-18 text-extra-bold mt-20 c-black-100">{text}</h2>;
const Divider = () => <HorizontalRule className="my-20" />;

const SettingField = ({ label, detail, children }: { label: string; detail?: string; children: React.ReactNode }) => (
    <>
        <div className="flex justify-between mt-20 c-black-100">
            <div className="fs-16">
                <p>{label}</p>
            </div>
            <div className="">{children}</div>
        </div>
        {detail && <div className="fs-12 c-black-50-2">{detail}</div>}
    </>
);

const NotificationSettingField = () => {
    const info = browserInfo();
    const error = getError(info);
    if (error) {
        return <InfoPaper className="mt-20">{i18n(error)}</InfoPaper>;
    }
    return (
        <SettingField label={i18n('nui.profileSettings.depositNotification')}>
            <NotificationsSwitch />
        </SettingField>
    );
};

function getError(info) {
    if (!info.browserSupported) {
        return 'nui.profileSettings.notifications.browserSupport';
    }
    if (info.browserDenied) {
        return 'nui.profileSettings.notifications.browserGranted';
    }
    return null;
}
